import { ActionIcon, Group, Paper, Skeleton } from "@mantine/core";

function SearchSkeleton() {
  return (
    <Paper withBorder p="md">
      <Group justify="space-between" wrap="nowrap">
        <Skeleton h="10px" />
        <ActionIcon variant="light" c="red">
          <Skeleton h="15px" w="15px" />
        </ActionIcon>
      </Group>
    </Paper>
  );
}

export default SearchSkeleton;
